@switch (versionNumber()) {
  @case (2) {
    <button
      #buttonV2
      class="u-button-v2"
      (click)="click($event)"
      [style]="styles()"
      [ngStyle]="customSize()"
      [ngClass]="styleClass()"
      [class.force-secondary-dark-mode]="forceSecondaryDarkMode()"
      [disabled]="['disabled', 'loading', 'readonly'].includes(stateElement())"
    >
      @if (stateElement() === 'loading') {
        <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      }
    </button>
  }
  @default {
    <button
      #button
      class="u-button"
      [ngClass]="[type + '-button', withIcon ? ' with-icon' : '', onlyIcon ? 'only-icon' : '', elementSize ?? '', active ? 'active' : '']"
      [disabled]="disabled || loading"
      (click)="click($event)"
      [style]="styles()"
      [class.force-secondary-dark-mode]="forceSecondaryDarkMode()"
    >
      @if (loading) {
        <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      }
    </button>
  }
}

<ng-template #loadingTemplate>
  <u-icon [model]="{ type: 'font', value: 'u-spin icon-spinner' }" [styles]="{ fontSize: '14px' }"></u-icon>
</ng-template>

<ng-template #contentTemplate>
  @if (fontIcon() && iconPos() === 'left') {
    <u-icon [model]="{ type: 'font', value: ICON_CLASS + fontIcon() + ' p-button-icon p-button-icon-left' }"></u-icon>
  }
  @if (label() && contentPos() === 'left') {
    <span class="p-button-label">{{ label() }}</span>
  }
  <ng-content></ng-content>
  @if (label() && contentPos() === 'right') {
    <span class="p-button-label">{{ label() }}</span>
  }
  @if (fontIcon() && iconPos() === 'right') {
    <u-icon [model]="{ type: 'font', value: ICON_CLASS + fontIcon() + ' p-button-icon p-button-icon-right' }"></u-icon>
  }
</ng-template>
